/**
 * The QC Dashboard became the QA sections of the one Dashboard (user, 2026-10-20;
 * docs/designs/qa-dashboard.md). Old bookmarks land there.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/qc-dashboard")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});
